import * as yup from "yup";
import {
  getStringRequiredFieldMessage,
  validatePhoneNumber,
} from "@shared/utils/yup-extensions";

export const createUserFormSchema = yup
  .object()
  .shape({
    name: yup
      .string()
      .trim()
      .min(1, getStringRequiredFieldMessage)
      .required()
      .label("Name"),
    email: yup
      .string()
      .email()
      .trim()
      .min(1, getStringRequiredFieldMessage)
      .required()
      .label("Email"),
    timezone: yup
      .string()
      .trim()
      .min(1, getStringRequiredFieldMessage)
      .required()
      .label("Time Zone"),
    countryState: yup
      .string()
      .trim()
      .min(1, getStringRequiredFieldMessage)
      .required()
      .label("State"),
    emailConfirmed: yup.boolean().required().label("Email confirmed"),
    subscriptionPlanId: yup
      .string()
      .trim()
      .min(1, getStringRequiredFieldMessage)
      .required()
      .label("Subscription Plan"),
    mlsId: yup.string().trim().label("License number"),
    officeName: yup
      .string()
      .trim()
      .min(1, getStringRequiredFieldMessage)
      .required()
      .label("Brokerage name"),
    phoneNumber: yup
      .string()
      .test(
        validatePhoneNumber({
          message: "Invalid phone number",
          region: "US",
          optional: true,
        })
      )
      .optional(),
    enabledMlsProvidersSelected: yup
      .array()
      .of(yup.string().required())
      .min(1, "At least one MLS Provider must be selected")
      .label("Enabled MLS Providers"),
  })
  .required();

export type CreateUserFormSchema = typeof createUserFormSchema.__outputType;

export const CREATE_USER_SCHEMA_DEFAULT_VALUES = {
  name: "",
  email: "",
  timezone: "auto-detect",
  countryState: "CA",
  subscriptionPlanId: "",
  phoneNumber: "",
  emailConfirmed: false,
  mlsId: "",
  officeName: "",
  enabledMlsProvidersSelected: [],
} satisfies CreateUserFormSchema;
